/**
 * Chrome and Safari throw `SecurityError` (DOMException code 18) when cookies
 * or storage are blocked. Chrome says access to `sessionStorage` is denied;
 * Safari says the operation is insecure. The throw happens on the property
 * access itself, before `getItem` runs. Callers must not let that reach an
 * error boundary.
 */
function isBlockedStorage(error: unknown): boolean {
  return (
    error instanceof DOMException &&
    (error.name === 'SecurityError' || error.code === 18)
  );
}

export function readSessionItem(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch (error) {
    if (isBlockedStorage(error)) return null;
    throw error;
  }
}

export function writeSessionItem(key: string, value: string): void {
  try {
    sessionStorage.setItem(key, value);
  } catch (error) {
    if (isBlockedStorage(error)) return;
    throw error;
  }
}

export function removeSessionItem(key: string): void {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    if (isBlockedStorage(error)) return;
    throw error;
  }
}
